import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type HouseHistorySliceType = {
  id?: number;
  visible: boolean;
  dynamicNumber?: number;
};

const initialState: HouseHistorySliceType = {
  visible: false,
  dynamicNumber: Math.random() * 10
};

export const houseSliceHistory = createSlice({
  name: 'house-history',
  initialState,
  reducers: {
    setVisibleHouseHistory: (
      state,
      action: PayloadAction<
        { visible: false; id?: number; dynamicNumber?: number } | { visible: true; id: number; dynamicNumber: number }
      >
    ) => {
      state.id = action.payload?.id;
      state.visible = action.payload.visible;
      state.dynamicNumber = action.payload?.dynamicNumber;
    }
  }
});

export default houseSliceHistory.reducer;
export const { setVisibleHouseHistory } = houseSliceHistory.actions;
